import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22739214"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-xl-5" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Projektdaten")
], -1))
const _hoisted_7 = { class: "table table-borderless table-xs my-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-hash mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Project-Id:")
], -1))
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-location4 mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Geodaten:")
], -1))
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-user mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Name:")
], -1))
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-map4 mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Anschrift:")
], -1))
const _hoisted_18 = { class: "text-right" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Telefon:")
], -1))
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-mention mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Email:")
], -1))
const _hoisted_24 = { class: "text-right" }
const _hoisted_25 = { class: "col-12 col-xl-7" }
const _hoisted_26 = { class: "card" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Alarmdetails")
], -1))
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Zeitpunkt ", -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "alert bg-accent-100 border-accent text-accent"
}
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Auslösegrund ", -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "alert bg-accent-100 border-accent text-accent"
}
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Alarmbericht ", -1))
const _hoisted_40 = ["href"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-pdf" }, null, -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Einsatzbericht ansehen")
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = {
  key: 1,
  class: "alert bg-accent-100 border-accent text-accent"
}
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Kontaktdaten Notruf- / Serviceleitstelle ", -1))
const _hoisted_47 = { class: "table table-borderless table-xs my-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-hash mr-2" }),
  /*#__PURE__*/_createTextVNode(" Alarmid:")
], -1))
const _hoisted_49 = { class: "text-right" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
    /*#__PURE__*/_createTextVNode(" AVZ Notrufleitstelle")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, "0371 911 995 99")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-person mr-2" }),
  /*#__PURE__*/_createTextVNode(" Ausgelöst durch:")
], -1))
const _hoisted_52 = { class: "text-right" }
const _hoisted_53 = { class: "col-12" }
const _hoisted_54 = { class: "card" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Einsatzbericht")
], -1))
const _hoisted_56 = { class: "card-body" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = {
  key: 0,
  class: "col-12 col-xl-6"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Feuerwehr ", -1))
const _hoisted_60 = { class: "table table-borderless table-xs my-2" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-hash mr-2" }),
  /*#__PURE__*/_createTextVNode(" Vorgangsnummer:")
], -1))
const _hoisted_62 = { class: "text-right" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Einsatzleiter:")
], -1))
const _hoisted_64 = { class: "text-right" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Rückrufnummer:")
], -1))
const _hoisted_66 = { class: "text-right" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Emailadresse:")
], -1))
const _hoisted_68 = { class: "text-right" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Einsatzkräfte Ankunft:")
], -1))
const _hoisted_70 = { class: "text-right" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Einsatzkräfte Abfahrt:")
], -1))
const _hoisted_72 = { class: "text-right" }
const _hoisted_73 = {
  key: 1,
  class: "col-12 col-xl-6"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Polizei ", -1))
const _hoisted_75 = { class: "table table-borderless table-xs my-2" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-hash mr-2" }),
  /*#__PURE__*/_createTextVNode(" Aktenzeichen:")
], -1))
const _hoisted_77 = { class: "text-right" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Einsatzleiter:")
], -1))
const _hoisted_79 = { class: "text-right" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Dienststelle:")
], -1))
const _hoisted_81 = { class: "text-right" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Rückrufnummer:")
], -1))
const _hoisted_83 = { class: "text-right" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Emailadresse:")
], -1))
const _hoisted_85 = { class: "text-right" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Einsatzkräfte Ankunft:")
], -1))
const _hoisted_87 = { class: "text-right" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Konnte jemand gestellt werden ?")
], -1))
const _hoisted_89 = { class: "text-right" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Wird es eine Rechnung geben ?")
], -1))
const _hoisted_91 = { class: "text-right" }
const _hoisted_92 = {
  key: 2,
  class: "col-12 col-xl-6"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Wachdienst ", -1))
const _hoisted_94 = { class: "table table-borderless table-xs my-2" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-hash mr-2" }),
  /*#__PURE__*/_createTextVNode(" Vorgangsnummer:")
], -1))
const _hoisted_96 = { class: "text-right" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Name des Wachdienst:")
], -1))
const _hoisted_98 = { class: "text-right" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Rückrufnummer:")
], -1))
const _hoisted_100 = { class: "text-right" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Emailadresse:")
], -1))
const _hoisted_102 = { class: "text-right" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Wachdienst Ankunft:")
], -1))
const _hoisted_104 = { class: "text-right" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Konnte jemand gestellt werden ?")
], -1))
const _hoisted_106 = { class: "text-right" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createTextVNode(" Wird es eine Rechnung geben ?")
], -1))
const _hoisted_108 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_8,
                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.details.pid), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.details.geodatenGenau), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.details.p_anrede), 1),
                  _hoisted_14,
                  (_ctx.details.p_firma != '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.details.p_firma), 1))
                    : _createCommentVNode("", true),
                  _hoisted_16,
                  _createElementVNode("span", null, _toDisplayString(_ctx.details.p_vorname) + " " + _toDisplayString(_ctx.details.p_name), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_17,
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.details.p_strasse) + " " + _toDisplayString(_ctx.details.p_hnr), 1),
                  _hoisted_19,
                  _hoisted_20,
                  _createElementVNode("span", null, _toDisplayString(_ctx.details.p_plz) + " " + _toDisplayString(_ctx.details.p_ort), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_21,
                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.details.p_tel), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_23,
                _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.details.p_email), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                (_ctx.reason)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.details.createdAt) + " Uhr", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, " Leider wurde kein Auslösezeitpunkt angegeben "))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                (_ctx.reason)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.reason), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, " Leider wurde kein Auslösegrund angegeben "))
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                (_ctx.details.einsatzbericht_pdf)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.details.einsatzbericht_pdf,
                      target: "_blank",
                      class: "btn btn-secondary"
                    }, _hoisted_43, 8, _hoisted_40))
                  : (_openBlock(), _createElementBlock("div", _hoisted_44, " Es ist leider kein Einsatzbericht vorhanden "))
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("table", _hoisted_47, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_48,
                      _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.details.alarm_id), 1)
                    ]),
                    _hoisted_50,
                    _createElementVNode("tr", null, [
                      _hoisted_51,
                      _createElementVNode("td", _hoisted_52, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.triggeredBy.anrede) + " " + _toDisplayString(_ctx.triggeredBy?.vorname.charAt(0)) + ". " + _toDisplayString(_ctx.triggeredBy.name), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              (_ctx.details.an_feuerwehr != '0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _hoisted_59,
                    _createElementVNode("table", _hoisted_60, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_61,
                          _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.details.fw_aktenzeichen), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_63,
                          _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.details.fw_kontakt_ap), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_65,
                          _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.details.fw_kontakt_tel), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_67,
                          _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.details.email_to_feuerwehr), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_69,
                          _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.details.fw_vorort), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_71,
                          _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.details.fw_abfahrt), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.details.an_polizei != '0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("table", _hoisted_75, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_76,
                          _createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.details.aktenzeichen), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_78,
                          _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.details.kontakt_ap), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_80,
                          _createElementVNode("td", _hoisted_81, _toDisplayString(_ctx.details.kontakt_dienststelle), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_82,
                          _createElementVNode("td", _hoisted_83, _toDisplayString(_ctx.details.kontakt_tel), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_84,
                          _createElementVNode("td", _hoisted_85, _toDisplayString(_ctx.details.email_to_polizei), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_86,
                          _createElementVNode("td", _hoisted_87, _toDisplayString(_ctx.details.polizei_vorort), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_88,
                          _createElementVNode("td", _hoisted_89, _toDisplayString(_ctx.details.jemand_gestellt), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_90,
                          _createElementVNode("td", _hoisted_91, _toDisplayString(_ctx.details.rechnung), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.details.an_wachdienst != '0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                    _hoisted_93,
                    _createElementVNode("table", _hoisted_94, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_95,
                          _createElementVNode("td", _hoisted_96, _toDisplayString(_ctx.details.wa_aktenzeichen), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_97,
                          _createElementVNode("td", _hoisted_98, _toDisplayString(_ctx.details.wa_kontakt_ap), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_99,
                          _createElementVNode("td", _hoisted_100, _toDisplayString(_ctx.details.wa_kontakt_tel), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_101,
                          _createElementVNode("td", _hoisted_102, _toDisplayString(_ctx.details.wa_email_to_polizei), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_103,
                          _createElementVNode("td", _hoisted_104, _toDisplayString(_ctx.details.wa_vorort), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_105,
                          _createElementVNode("td", _hoisted_106, _toDisplayString(_ctx.details.wa_jemand_gestellt), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_107,
                          _createElementVNode("td", _hoisted_108, _toDisplayString(_ctx.details.wa_rechnung), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}